import type { ReactNode } from 'react'
import type { components } from '@/api/schema'
import { AutomationHistory } from '@/components/automation-history'
import { Label } from '@/components/ui/label'
import { Switch } from '@/components/ui/switch'

type AutomationChange = components['schemas']['AutomationChangeRead']

/**
 * The Automation switch of a project, PO or AP invoice: what it stops, an
 * optional note on why it can't be turned on here, and who changed it when.
 */
export function AutomationSwitch({
  id,
  description,
  note,
  checked,
  disabled,
  onCheckedChange,
  history,
  historyLoading,
  showScope = false,
  hideLabel = false,
}: {
  id: string
  description: string
  note?: ReactNode
  checked: boolean
  disabled: boolean
  onCheckedChange: (checked: boolean) => void
  history: AutomationChange[] | undefined
  historyLoading: boolean
  showScope?: boolean
  /** Keep the "Automation" label for screen readers only, under a heading that already says it. */
  hideLabel?: boolean
}) {
  return (
    <>
      <div className="flex items-start justify-between gap-4">
        <div className="space-y-0.5">
          <Label htmlFor={id} className={hideLabel ? 'sr-only' : 'text-sm font-medium'}>
            Automation
          </Label>
          <p className="text-xs text-muted-foreground">{description}</p>
          {note && <p className="text-xs text-amber-600 dark:text-amber-500">{note}</p>}
        </div>
        <Switch
          id={id}
          checked={checked}
          onCheckedChange={onCheckedChange}
          disabled={disabled}
        />
      </div>
      <AutomationHistory changes={history} isLoading={historyLoading} showScope={showScope} />
    </>
  )
}
